var React = require('react');

function CheckCircleInvertedIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFFFFF","cx":"12","cy":"12","r":"8","key":0}),React.createElement("path",{"fill":"currentColor","d":"m12 2a10 10 0 1 0 10 10 10 10 0 0 0 -10-10zm0 18a8 8 0 1 1 8-8 8.00905 8.00905 0 0 1 -8 8z","key":1}),React.createElement("path",{"fill":"currentColor","d":"m10.46191 15.76953a.99928.99928 0 0 1 -.707-.293l-2.46191-2.46188a.99989.99989 0 0 1 1.414-1.41406l1.75488 1.75488 4.83106-4.832a.99989.99989 0 0 1 1.41406 1.41403l-5.538 5.53906a.99929.99929 0 0 1 -.70709.29297z","key":2})]);
}

CheckCircleInvertedIcon.defaultProps = {"data-dmid":"dm-circle-check-inverted","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color6"};

module.exports = CheckCircleInvertedIcon;

CheckCircleInvertedIcon.default = CheckCircleInvertedIcon;
